import React from 'react';
import {type SiteFilter, type Department} from '../types/types';
import themeDisplay from '../services/liferay/theme-display';

export type LetterProperties = {
	selectedFilter: SiteFilter;
	departments: Department[];
};

function Letters({departments, selectedFilter}: Readonly<LetterProperties>): JSX.Element {
	const alphabet: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

	const [activeLetters, setActiveLetters] = React.useState<string[]>([]);

	React.useEffect(() => {
		const letters: string[] = [];
		const filteredDepartments = departments.filter(department => department.siteFilter.includes(selectedFilter));

		for (const department of filteredDepartments) {
			const firstLetter = department.label.charAt(0).toUpperCase();

			if (!letters.includes(firstLetter)) {
				letters.push(firstLetter);
			}
		}

		setActiveLetters(letters);
	}, [departments, selectedFilter]);

	return (
		<div className='abc-header-letter'>
			{themeDisplay.getLanguageId() === 'nl_NL' ? 'Navigeer snel naar:' : 'Dirigez-vous vers :'}
			{alphabet.map(letter => (
				<span key={letter} className={activeLetters.includes(letter) ? 'abc-header-letter' : 'abc-header-inactive-letter'}>
					{activeLetters.includes(letter) ? <a href ={`#${letter}`}>{letter}</a> : letter}
				</span>
			))}
		</div>
	);
}

export default Letters;
